import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { AuthProvider } from './contexts/AuthContext'
import Header from './components/Header'
import Footer from './components/Footer'
import { AppLoader, ErrorBoundary, NotFound } from './components'
import GoogleOAuthTest from './components/GoogleOAuthTest'
import TestConnection from './components/TestConnection'
import './App.css'

// Create a client
const queryClient = new QueryClient()

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'))
const Rooms = lazy(() => import('./pages/Rooms'))
const RoomDetail = lazy(() => import('./pages/RoomDetail'))
const Booking = lazy(() => import('./pages/Booking'))
const BookingSuccess = lazy(() => import('./pages/BookingSuccess'))
const BookingConfirmation = lazy(() => import('./pages/BookingConfirmation'))
const ThreeDSRedirect = lazy(() => import('./components/ThreeDSRedirect'))
const PaymentTest = lazy(() => import('./pages/PaymentTest'))
const MisReservas = lazy(() => import('./components/MisReservas'))

function App() {
  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || 'your-google-client-id'}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Router>
            <div className="App">
              <Header />
              <main className="main-content">
                <ErrorBoundary>
                  <Suspense fallback={<AppLoader text="Cargando página..." />}>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/habitaciones" element={<Rooms />} />
                      <Route path="/habitacion/:id" element={<RoomDetail />} />
                      <Route path="/reservar/:id" element={<Booking />} />
                      <Route path="/booking-success" element={<BookingSuccess />} />
                      <Route path="/booking/confirmation" element={<BookingConfirmation />} />
                      <Route path="/mis-reservas" element={<MisReservas />} />
                      <Route path="/3ds-redirect" element={<ThreeDSRedirect />} />
                      <Route path="/payment-test" element={<PaymentTest />} />
                      <Route path="/oauth-test" element={<GoogleOAuthTest />} />
                      <Route path="/connection-test" element={<TestConnection />} />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </Suspense>
                </ErrorBoundary>
              </main>
              <Footer />
            </div>
          </Router>
        </AuthProvider>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  )
}

export default App